import {Component, inject} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {FormElementComponent} from "../../../core/components/form-element/form-element.component";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ContactService} from "../../services/contact.service";
import {PageBase} from "../../../core/components/page-base";

@Component({
  selector: 'app-contact-single',
  standalone: true,
  imports: [
    FormElementComponent,
    ReactiveFormsModule
  ],
  templateUrl: './contact-single.component.html',
  styleUrl: './contact-single.component.scss'
})
export class ContactSingleComponent extends PageBase {
  private contactService = inject(ContactService);

  contactForm = new FormGroup({
    name: new FormControl('', [
      Validators.required,
    ]),
    email: new FormControl('', [
      Validators.required,
      Validators.email,
    ]),
    phone: new FormControl('', [
      Validators.required,
    ]),
    text: new FormControl('', [
      Validators.required,
    ]),
    recaptchaResponseToken: new FormControl('', [
      // Validators.required,
    ]),
  });

  protected submitInquiry(): void {
    this.contactForm.markAllAsTouched();
    if (this.contactForm.valid) {
      const name = this.contactForm.get('name')?.value ?? '';
      const email = this.contactForm.get('email')?.value ?? '';
      const phone = this.contactForm.get('phone')?.value ?? '';
      const text = this.contactForm.get('text')?.value ?? '';
      const recaptchaResponseToken = this.contactForm.get('recaptchaResponseToken')?.value ?? '';

      this.contactService.sendEmail(name, email, phone, text, recaptchaResponseToken).subscribe({
          next: resultJson => {
            if (resultJson.result === 1) {
              this.snackBar.open('Запитването ви е изпратено успешно.', '×', {
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: 'success',
              });
            } else {
              this.snackBar.open('Грешка при изпращане на заптиване, моля опитайте отново.', '×', {
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: 'error',
              });
            }
          },
          error: err => {
            console.log(err);
          },
        }
      );
    }
  }

  override ngOnInit(): void {
    this.pageTitle = "Как да се свържa с Мини Заем. - Minizaem.bg";
    this.metaDescription = "Как да се свържа с Мини Заем. Адрес, телефони, форма за контакт.";
    super.ngOnInit();
  }
}
